/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
import map from 'lodash/map';
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */
import { SagaIterator } from 'redux-saga';
import { call, cancel, delay, fork, put, select, take } from 'redux-saga/effects';

import { setSessionStorageData } from '../../../modules/storage/storageActions';
import { makeSelectTimers } from '../../../modules/storage/storageSelectors';
import { stopTick } from '../actions/tableActions';
import { START_TICK, STOP_TICK } from '../constants/actionConstants';

const DELAY_TIME = 1000;

export function* updateConfigSaga(): SagaIterator {
    const timers = yield select(makeSelectTimers());
    const newTimers = map(timers, (timer) =>
        ({ ...timer, ...{ time: timer.time - DELAY_TIME } }))
        .filter(e => e.time !== 0);
    if (newTimers.length > 0) {
        yield put(setSessionStorageData({ key: 'timers', value: newTimers }));
    } else {
        yield put(setSessionStorageData({ key: 'timers', value: [] }));
        yield put(stopTick());
    }
}

export function* tickSaga(): SagaIterator {
    while (true) {
        yield delay(DELAY_TIME);
        yield call(updateConfigSaga);
    }
}

export default function* watchTimerSaga(): SagaIterator {
    while (yield take(START_TICK)) {
        const bgSyncTask = yield fork(tickSaga);
        yield take(STOP_TICK);
        yield cancel(bgSyncTask);
    }
}
